<template>
 <div>
  <div v-if="isReport">
    <div class="padding-container-sm">
      <div class="row">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-10">
              <b-input-group size="md border-right">
                <b-input-group-text slot="append" class="bg-white">
                  <strong>
                    <i class="ion-md-search" @click="onSearchText" />
                  </strong>
                </b-input-group-text>
                <b-form-input
                  class="border-right-0"
                  :value="filter.searchValue"
                  placeholder="Search for patient"
                  @keyup.enter.native="onSearchText"
                />
              </b-input-group>
            </div>
            <div class="col-md-2">
              <div class="btn btn-link" @click="resetFilters">
                <strong>
                  <i class="ion-md-refresh mr-1" />
                </strong>Reset
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2 pb-2 text-right">
          <b-form-select
            v-validate="'required'"
            v-model="filter.day"
            name="plan_duration"
            @change="subtractMonth">
            <option value="currentMonth">Current Month</option>
            <option value="lastMonth">Last Month</option>
            <option value="firstQuarter">First Quarter</option>
            <option value="secondQuarter">Second Quarter</option>
            <option value="thirdQuarter">Third Quarter</option>
            <option value="fourthQuarter">Fourth Quarter</option>
            <option value="yearly">Year</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <v-table :options="tableProps" :total-count="Number(totalCount)" :data="reports">
      <template slot="actions" slot-scope="slotProps">
        <span v-if="slotProps" class="d-flex justify-content-around">
          <button class="btn-modify" @click="viewReport(slotProps.data.datum)">
            <i class="icon ion-md-eye" />View Report
          </button>
        </span>
      </template>

      <template slot="patientName" slot-scope="slotProps">
          <div class="d-flex flex-column justify-content-center" v-if="slotProps">
            <span>
              {{ slotProps.data.datum.user.first_name | capitalizefirst }}
              {{ slotProps.data.datum.user.last_name | capitalizefirst }}
            </span>
          </div>
        </template>

    </v-table>
  </div>
  <div v-else>
    <ViewReport
      @send-message="handleSendMessage"
      :day="filter.day"
      :quarter="quarter"
      :dateContext="dateContext"
      :selectedPatient="selectedPatient"
    />
  </div>
      <v-loader :isLoading="isLoading" />
 </div>
</template>

<script>
import VTable from "@/components/table/index.vue";
import moment from "moment";
import VLoader from "@/components/loader/index.vue";
import ViewReport from "@/components/reports/adherence/View/Index.vue";
import { mapGetters } from "vuex";

export default {
  name: "adherence",
  components: {
    VTable,
    ViewReport,
    VLoader
  },
  data() {
    return {
      filter: {
        searchValue: "",
        day: "currentMonth",
        status:"all",
        limit:20,
        pageNo:1        
      },
      dateContext: moment(),
      isReport: true,
      quarter:0,
      selectedPatient: {},
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellSlot: {
              name: "patientName"
            },
            dataKey: "mr_id",
            dataType: String,
            label: "Patient name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            dataKey: "status",
            dataType: String,
            label: "Care Plan"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "actions"
            },
            disablePadding: false,
            label: "Actions"
          }
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 20,
        title: "Reports"
      }
    };
  },
  computed: {
    previousMonth: function() {
      return moment().subtract(1, "month");
    },
    ...mapGetters({
      reports: "reports/getallPatients",
      isLoading: "reports/getIsallPatientsLoading",
      totalCount: "reports/getallPatientsCount"
    })
  }, 
  watch: {
    filter: {
      handler: "fetchReports",
      immediate: true
    }
  },
  methods: {
    fetchReports() {
      this.$store.dispatch("reports/getAllPatientList", this.filter);
    },
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
    },
    subtractMonth: function() {
      switch (this.filter.day) {
        case "currentMonth":
          this.dateContext = moment();
          break;
        case "lastMonth":
          this.dateContext = this.previousMonth;
          break;
        case "firstQuarter":
          this.quarter = 1;
          break;
        case "secondQuarter":
          this.quarter = 2;
          break;
        case "thirdQuarter":
          this.quarter = 3;
          break;
        case "fourthQuarter":
          this.quarter = 4;
          break;
        default:
          break;  
      }
    },
    resetFilters() {
      this.filter = {
        searchValue: "",
        day: "currentMonth",
        status:"all",
        limit:10,
        pageNo:1 
      };
    },
    viewReport(patient) {
      this.isReport = false;
      this.selectedPatient = patient;
    },
    onSearchText(event) {
      this.tableProps = {
        ...this.tableProps,
        page: 1
      };
      this.filter = {
        ...this.filter,
        searchValue: event.target.value
      };
    },
    handleSendMessage() {
      this.isReport = true;
    }
  }
};
</script>
